
export const getEdgesForStreamUrl = (edgeItems) => ({
  preferredEdgesIds: edgeItems.filter(edgeItem => !edgeItem.isDeath).map(edgeItem => edgeItem.edges_id),
  nonpreferredEdgesIds: edgeItems.filter(edgeItem => edgeItem.isDeath).map(edgeItem => edgeItem.edges_id),
});
